<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="repromaterijalTable"
    [chipItems]="chipItems"
    [isTableLoading]="isLoading"
  >
  </kodit-table>
</kodit-page>
